import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import { toast } from "sonner";
import { Btn, Field, Page, TopBar } from "@/components/kit";
import BusinessFields, { cleanBusiness, validateBusiness } from "@/components/BusinessFields";
import { useAuth } from "@/context/auth";
import { api } from "@/lib/api";

export default function EditProfile() {
  const nav = useNavigate();
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name ?? "");
  const [biz, setBiz] = useState({ businessCategoryId: user?.businessCategoryId ?? "", companyName: user?.companyName ?? "", designation: user?.designation ?? "" });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const hasBiz = Object.values(biz).some((v) => v.trim()) || !!(user?.businessCategoryId || user?.companyName || user?.designation);

  const save = async () => {
    const next = hasBiz ? validateBusiness(biz) : {};
    if (name.trim().length < 2) next.name = "Please enter your full name.";
    setErrors(next);
    if (Object.keys(next).length) return;
    setSaving(true);
    try {
      const u = await api.patch("/users/me", { name: name.trim(), ...(hasBiz ? cleanBusiness(biz) : {}) });
      setUser(u);
      toast.success("Profile updated.");
      nav("/profile");
    } catch (e) {
      toast.error(e.message || "Could not save changes.");
    } finally {
      setSaving(false);
    }
  };
  return (
    <Page>
      <TopBar title="Edit Profile" />
      <div className="flex flex-col gap-5 max-w-xl mt-2">
        <Field label="Full Name *" icon={User} value={name} onChange={(e) => setName(e.target.value)} error={errors.name} maxLength={120} testid="edit-profile-name" />
        <h2 className="t-section -mb-1">Business details</h2>
        <BusinessFields prefix="edit-profile" value={biz} onChange={setBiz} errors={errors} />
        <Btn onClick={save} loading={saving} testid="edit-profile-save">Save Changes</Btn>
      </div>
    </Page>
  );
}
